// extracted by mini-css-extract-plugin
module.exports = {"grid":"icon-card_grid__dFQGY","iconCard":"icon-card_iconCard__zyFdH","textContainer":"icon-card_textContainer___DS87","link":"icon-card_link___AGYK"};